import { Controller } from "@hotwired/stimulus"
import Packery from 'packery'
import fitty from 'fitty'

// Manages the Mosaic Collage ("JCB") cast design preview layout.
// Initialises Packery bin-packing on the grid items and fitty on any
// .fit-text elements. The 1500ms delay allows placeholder images to
// finish rendering before Packery calculates positions.
export default class extends Controller {
  connect() {
    this.initTimeout = setTimeout(() => this.init(), 500)
  }

  disconnect() {
    clearTimeout(this.initTimeout)
    this.packeryInstance?.destroy()
    this.fittyInstances?.forEach(f => f.unsubscribe())
  }

  init() {
    this.packeryInstance = new Packery(this.element, {
      itemSelector: '.p',
      gutter: 5,
      percentPosition: true,
    })

    const fitTextEls = this.element.querySelectorAll('.fit-text')
    this.fittyInstances = [...fitTextEls].map(el => fitty(el))
  }
}
